/** Email clicable → mailto. */
export default function CitaLinkEmail({ email, color = "#f97316", style = {} }) {
  const e = email != null ? String(email).trim() : "";
  if (!e) return null;
  return (
    <a
      href={`mailto:${e}`}
      onClick={(ev) => ev.stopPropagation()}
      title="Enviar correo"
      style={{
        fontSize: "inherit",
        fontWeight: 600,
        color,
        textDecoration: "underline",
        cursor: "pointer",
        ...style,
      }}
    >
      {e}
    </a>
  );
}
